export enum DriverTagEnum {
  null = 0,
  DRIVER_HAS_INTEREST = 1,
  DRIVER_CONTACTED_YOU,
  YOU_CONTACTED_DRIVER,
  DRIVER_CLOSE_WITH_YOU,
  DRIVER_HIRED,
  SEARCHED_BY_YOU,
}

export enum DriverTypeEnum {
  VEHICLE,
  PERSON,
}

export type TVehicleType = {
  id: number;
  name: string;
};

export type TSort = 'distance' | 'rate' | 'dateLastLocation';
export type TSortAmplitude = 'cargo-proximity' | 'rate' | 'recent-location';
export type TFilterTruckerType = 'pf' | 'pj' | 'hasPermission';

export type TVehicle = {
  category: string;
  types: TVehicleType[];
};

export type TAreaCode = {
  areaCode: number;
  text: string;
};

export type TTruckersLimit = {
  locked: number;
  unlocked: number;
};

export type TExtraTruckersConsumption = {
  consumed: number;
  freeLimit: number;
  freeAvailable: number;
};

export type TExtraTruckers = {
  maxLimitView: number;
  hasConsumed: boolean;
  consumption: TExtraTruckersConsumption;
};

export type TFreightCard = {
  wasSearchedByCpf?: boolean;
  cachedAt: string;
  truckersLimitsTotal?: TTruckersLimit;
  freight?: {
    code: string;
    origin: {
      city: string;
      federativeUnit: string;
    };
    destination: {
      city: string;
      federativeUnit: string;
    };
    vehicleTypes: TVehicle[];
    score: {
      unlocked: boolean;
    };
    tag: string;
  };
  areaCodes: TAreaCode[];
  pagination: {
    next: number;
    page: number;
    previous: number;
    total: number;
    reachedEnd: boolean;
  };
  extrasTruckers: TExtraTruckers;
};

export type TTruckerPerson = {
  id: string;
  uuid: string;
  selfieUri: string;
  name: string;
  verified: boolean;
  alreadyNotified: boolean;
  isVip: boolean;
  areaCodes: number[];
  whereIs: string;
};

export type TTruckerVehicle = {
  id: string;
  name?: string;
  plate: string;
  type: number;
  ownerType: number;
  bodyName: string;
  typeName: string;
};

export type TTruckerCheckIn = {
  createdAt: string;
  destination: string;
  originCity: string;
  originState: string;
};

export type TTruckerLastLocation = {
  distance?: number;
  date?: string;
  verified: boolean;
  coordinate: {
    lat: number;
    lng: number;
  };
};

export type TTruckerItem = {
  vehicle: TTruckerVehicle;
  person: TTruckerPerson;
  lastLocation: TTruckerLastLocation;
  checkin: TTruckerCheckIn;
  tag: DriverTagEnum;
  rate?: number;
  hasPermission: boolean;
};

export type TTruckerActiveItem = TTruckerItem & {
  id: string;
  type: DriverTypeEnum;
};

export type TTruckerState = {
  meta: TFreightCard;
  radius: number;
  activeDriver: TTruckerActiveItem;
  profileAutoLoad: boolean;
  sort: TSort;
  truckerType: TFilterTruckerType[];
  vehicles: number[];
  areaCodes: number[];
  isFilterApplied: boolean;
};

export type TFreightItem = {
  id: string;
  freightCode: string;
  route: {
    origin: {
      state: string;
      city: string;
    };
    destination: {
      state: string;
      city: string;
    };
  };
  publisher: string;
  createdDate: string;
  updatedDate: string;
  disabled: boolean;
  onChecked: (id: string) => (isCheck: boolean) => void;
  vehicles: Array<string>;
  bodyWorks: Array<string>;
  product: string;
  tag: string;
  price: {
    type: string;
    value: string;
  };
};
